import { QueryClient } from "@tanstack/react-query";
import { isNotFound, isUnauthorized } from "./api";
import { setTelemetryUser } from "./telemetry";

/**
 * One cache for the whole tab.
 *
 * Reads are cached for a minute by default; immutable version queries choose
 * an infinite stale time. A 401 or 404 is an answer, not a flake, so those are
 * not retried; everything else gets one more go.
 */
export function createQueryClient(): QueryClient {
  const client = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60_000,
        gcTime: 10 * 60_000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) =>
          !isUnauthorized(error) && !isNotFound(error) && failureCount < 1,
      },
    },
  });
  client.getQueryCache().subscribe(event => {
    if (event.query.queryKey[0] !== "session") return;
    const data = event.query.state.data as { user: { id: string } } | null | undefined;
    setTelemetryUser(event.type === "removed" ? null : (data?.user.id ?? null));
  });
  return client;
}
